import { TPannellumConfig } from '../../types/panellum';

const basePath = 'https://static.treedis.com/projects/shviro';

export const pannellumConfigShviro: { [key: number]: TPannellumConfig } = {
  1: {
    type: 'multires',
    multiRes: {
      basePath: `${basePath}/pano/multires/1`,
      path: '/%l/%s%y_%x',
      fallbackPath: '/fallback/%s',
      extension: 'jpg',
      tileResolution: 512,
      maxLevel: 4,
      cubeResolution: 2544,
    },
    pitch: -15,
    hfov: 110,
    hotSpots: [
      // Building hotspots
      {
        pitch: -6,
        yaw: -21,
        type: 'info',
        createTooltipArgs: { title: 'E', type: 'building' },
      },
      {
        pitch: -7.9,
        yaw: 9,
        type: 'info',
        createTooltipArgs: { title: 'C1', type: 'building' },
      },
      {
        pitch: -7.2,
        yaw: 25,
        type: 'info',
        createTooltipArgs: { title: 'C2', type: 'building' },
      },
      {
        pitch: -8,
        yaw: -4.8,
        type: 'info',
        createTooltipArgs: { title: 'B1', type: 'building' },
      },
      {
        pitch: -5.6,
        yaw: 4.7,
        type: 'info',
        createTooltipArgs: { title: 'B2', type: 'building' },
      },
      {
        pitch: -4.4,
        yaw: -1.2,
        type: 'info',
        createTooltipArgs: { title: 'A2', type: 'building' },
      },
      {
        pitch: -4,
        yaw: -12,
        type: 'info',
        createTooltipArgs: { title: 'A1', type: 'building' },
      },
      {
        pitch: -3.2,
        yaw: -24.5,
        type: 'info',
        createTooltipArgs: { title: 'D', type: 'building' },
      },
      // POI Hotspots
      {
        pitch: 1.2092379103848236,
        yaw: -105.75069015852728,
        type: 'info',
        createTooltipArgs: {
          title: 'תל אביב',
          stem: 50,
          type: 'poi',
          cardDescription: 'ניר צבי, ישראל',
          cardImageSrc: `${basePath}/pano/tags/tel-aviv.webp`,
          transportation: { car: 30 },
        },
      },
      {
        pitch: 0.9578681057785041,
        yaw: -82.29332484963692,
        type: 'info',
        createTooltipArgs: {
          title: 'כביש 1',
          stem: 50,
          type: 'poi',
          cardDescription: 'ישראל',
          cardImageSrc: `${basePath}/pano/tags/highway-2.webp`,
          transportation: { car: 12 },
        },
      },
      {
        pitch: 1.686307158904096,
        yaw: -61.97925218998455,
        type: 'info',
        createTooltipArgs: {
          title: 'שדה תעופה',
          stem: 50,
          type: 'poi',
          cardDescription: 'ישראל',
          cardImageSrc: `${basePath}/pano/tags/airport.webp`,
          transportation: { car: 21 },
        },
      },
      {
        pitch: 0.9025745169280146,
        yaw: 31.086238705725464,
        type: 'info',
        createTooltipArgs: {
          title: 'כביש 40',
          stem: 50,
          type: 'poi',
          cardDescription: 'ישראל',
          cardImageSrc: `${basePath}/pano/tags/highway-201.webp`,
          transportation: { car: 10 },
        },
      },
      {
        pitch: 2.7743106351877973,
        yaw: 102.22121530366837,
        type: 'info',
        createTooltipArgs: {
          title: 'רמלה',
          stem: 50,
          type: 'poi',
          cardDescription: 'ישראל',
          cardImageSrc: `${basePath}/pano/tags/ramia.webp`,
          transportation: { car: 10 },
        },
      },
      {
        pitch: 2.097920216387435,
        yaw: 147.4733251792603,
        type: 'info',
        createTooltipArgs: {
          title: 'ניר צבי',
          stem: 50,
          type: 'poi',
          cardDescription: 'ישראל',
          cardImageSrc: `${basePath}/pano/tags/nir-tzvi.webp`,
          transportation: { car: 15 },
        },
      },
      {
        pitch: 2.6793205894943783,
        yaw: 163.28640293525177,
        type: 'info',
        createTooltipArgs: {
          title: 'ראשון לציון',
          stem: 50,
          type: 'poi',
          cardDescription: 'ישראל',
          cardImageSrc: `${basePath}/pano/tags/rishon-lezion.webp`,
          transportation: { car: 25 },
        },
      },
      {
        pitch: 4,
        yaw: 40,
        type: 'scene',
        createTooltipArgs: {
          title: 'תצפית 2',
          stem: 50,
          type: 'scene',
          sceneId: 2,
          imgSrc: `${basePath}/pano/tags/scene_2.webp`,
        },
      },
      {
        pitch: 5,
        yaw: 0,
        type: 'scene',
        createTooltipArgs: {
          title: 'תצפית 3',
          stem: 50,
          type: 'scene',
          sceneId: 3,
          imgSrc: `${basePath}/pano/tags/scene_3.webp`,
        },
      },
    ],
  },
  2: {
    type: 'multires',
    multiRes: {
      basePath: `${basePath}/pano/multires/2`,
      path: '/%l/%s%y_%x',
      fallbackPath: '/fallback/%s',
      extension: 'jpg',
      tileResolution: 512,
      maxLevel: 4,
      cubeResolution: 2544,
    },
    pitch: -15,
    hfov: 110,
    hotSpots: [
      // Building hotspots
      {
        pitch: -2.658819660089957,
        yaw: 2.089312627061304,
        type: 'info',
        createTooltipArgs: { title: 'E', type: 'building' },
      },
      {
        pitch: -4.9437704857890425,
        yaw: -17.090286882511577,
        type: 'info',
        createTooltipArgs: { title: 'C1', type: 'building' },
      },
      {
        pitch: -6.708289578821616,
        yaw: -30.03486807804927,
        type: 'info',
        createTooltipArgs: { title: 'C2', type: 'building' },
      },
      {
        pitch: -9.855098341281652,
        yaw: 2.398753932927775,
        type: 'info',
        createTooltipArgs: { title: 'B1', type: 'building' },
      },
      {
        pitch: -9.944878668188274,
        yaw: -18.043098863699583,
        type: 'info',
        createTooltipArgs: { title: 'B2', type: 'building' },
      },
      {
        pitch: -20.697856440418263,
        yaw: -0.3599925174588634,
        type: 'info',
        createTooltipArgs: { title: 'A2', type: 'building' },
      },
      {
        pitch: -13.440967233696437,
        yaw: 24.486953488519816,
        type: 'info',
        createTooltipArgs: { title: 'A1', type: 'building' },
      },
      {
        pitch: -2.55536966032719,
        yaw: 12.56803630140621,
        type: 'info',
        createTooltipArgs: { title: 'D', type: 'building' },
      },
      // POI hotspots
      {
        pitch: 1.8822826712484,
        yaw: 55.83655903377519,
        type: 'info',
        createTooltipArgs: {
          title: 'תל אביב',
          stem: 50,
          type: 'poi',
          cardDescription: 'ניר צבי, ישראל',
          cardImageSrc: `${basePath}/pano/tags/tel-aviv.webp`,
          transportation: { car: 30 },
        },
      },
      {
        pitch: 1.6651790160323452,
        yaw: 84.68973894180533,
        type: 'info',
        createTooltipArgs: {
          title: 'כביש 1',
          stem: 50,
          type: 'poi',
          cardDescription: 'ישראל',
          cardImageSrc: `${basePath}/pano/tags/highway-2.webp`,
          transportation: { car: 12 },
        },
      },
      {
        pitch: 0.5355406005830474,
        yaw: 113.90123452296518,
        type: 'info',
        createTooltipArgs: {
          title: 'שדה תעופה',
          stem: 50,
          type: 'poi',
          cardDescription: 'ישראל',
          cardImageSrc: `${basePath}/pano/tags/airport.webp`,
          transportation: { car: 21 },
        },
      },
      {
        pitch: -1.2657944167656403,
        yaw: -170.50455488213777,
        type: 'info',
        createTooltipArgs: {
          title: 'כביש 40',
          stem: 50,
          type: 'poi',
          cardDescription: 'ישראל',
          cardImageSrc: `${basePath}/pano/tags/highway-201.webp`,
          transportation: { car: 10 },
        },
      },
      {
        pitch: 1.6557890691545976,
        yaw: -121.97249039807855,
        type: 'info',
        createTooltipArgs: {
          title: 'רמלה',
          stem: 50,
          type: 'poi',
          cardDescription: 'ישראל',
          cardImageSrc: `${basePath}/pano/tags/ramia.webp`,
          transportation: { car: 10 },
        },
      },
      {
        pitch: 0.041090837370232336,
        yaw: -72.40918272960494,
        type: 'info',
        createTooltipArgs: {
          title: 'ניר צבי',
          stem: 50,
          type: 'poi',
          cardDescription: 'ישראל',
          cardImageSrc: `${basePath}/pano/tags/nir-tzvi.webp`,
          transportation: { car: 15 },
        },
      },
      {
        pitch: 1.1145251985543547,
        yaw: -50.90336772740284,
        type: 'info',
        createTooltipArgs: {
          title: 'ראשון לציון',
          stem: 50,
          type: 'poi',
          cardDescription: 'ישראל',
          cardImageSrc: `${basePath}/pano/tags/rishon-lezion.webp`,
          transportation: { car: 25 },
        },
      },
      // Scene transition hotspots
      {
        pitch: 5,
        yaw: -40,
        type: 'scene',
        createTooltipArgs: {
          title: 'תצפית 1',
          stem: 50,
          type: 'scene',
          sceneId: 1,
          imgSrc: `${basePath}/pano/tags/scene_1.webp`,
        },
      },
      {
        pitch: 5,
        yaw: 40,
        type: 'scene',
        createTooltipArgs: {
          title: 'תצפית 3',
          stem: 50,
          type: 'scene',
          sceneId: 3,
          imgSrc: `${basePath}/pano/tags/scene_3.webp`,
        },
      },
    ],
  },
  3: {
    type: 'multires',
    multiRes: {
      basePath: `${basePath}/pano/multires/3`,
      path: '/%l/%s%y_%x',
      fallbackPath: '/fallback/%s',
      extension: 'jpg',
      tileResolution: 512,
      maxLevel: 4,
      cubeResolution: 2544,
    },
    pitch: -15,
    hfov: 110,
    yaw: 17,
    hotSpots: [
      // Building hotspots
      {
        pitch: -6.203538115784984,
        yaw: 55.4599409557826,
        type: 'info',
        createTooltipArgs: { title: 'E', type: 'building' },
      },
      {
        pitch: -7.239103941637902,
        yaw: 29.211226302354817,
        type: 'info',
        createTooltipArgs: { title: 'C1', type: 'building' },
      },
      {
        pitch: -5.368624853917067,
        yaw: 16.884452967264906,
        type: 'info',
        createTooltipArgs: { title: 'C2', type: 'building' },
      },
      {
        pitch: -11.954215081253395,
        yaw: 10.649996210325753,
        type: 'info',
        createTooltipArgs: { title: 'B1', type: 'building' },
      },
      {
        pitch: -7.6922016178348525,
        yaw: -2.1670851289321718,
        type: 'info',
        createTooltipArgs: { title: 'B2', type: 'building' },
      },
      {
        pitch: -7.196240232276747,
        yaw: -19.46327510423862,
        type: 'info',
        createTooltipArgs: { title: 'A2', type: 'building' },
      },
      {
        pitch: -14.583242864323749,
        yaw: -11.298519100824592,
        type: 'info',
        createTooltipArgs: { title: 'A1', type: 'building' },
      },
      {
        pitch: -10.67967942377063,
        yaw: 46.148750399003575,
        type: 'info',
        createTooltipArgs: { title: 'D', type: 'building' },
      },
      // POI hotspots
      {
        pitch: 0.6574089522285445,
        yaw: -177.04573902951972,
        type: 'info',
        createTooltipArgs: {
          title: 'תל אביב',
          stem: 50,
          type: 'poi',
          cardDescription: 'ניר צבי, ישראל',
          cardImageSrc: `${basePath}/pano/tags/tel-aviv.webp`,
          transportation: { car: 30 },
        },
      },
      {
        pitch: 1.0095665661914197,
        yaw: -148.77783587705875,
        type: 'info',
        createTooltipArgs: {
          title: 'כביש 1',
          stem: 50,
          type: 'poi',
          cardDescription: 'ישראל',
          cardImageSrc: `${basePath}/pano/tags/highway-2.webp`,
          transportation: { car: 12 },
        },
      },
      {
        pitch: 0.8325097674823434,
        yaw: -127.3661718698138,
        type: 'info',
        createTooltipArgs: {
          title: 'שדה תעופה',
          stem: 50,
          type: 'poi',
          cardDescription: 'ישראל',
          cardImageSrc: `${basePath}/pano/tags/airport.webp`,
          transportation: { car: 21 },
        },
      },
      {
        pitch: 1.302106181927046,
        yaw: -39.05082507228974,
        type: 'info',
        createTooltipArgs: {
          title: 'כביש 40',
          stem: 50,
          type: 'poi',
          cardDescription: 'ישראל',
          cardImageSrc: `${basePath}/pano/tags/highway-201.webp`,
          transportation: { car: 10 },
        },
      },
      {
        pitch: 2.6058574485912005,
        yaw: 41.747547526969015,
        type: 'info',
        createTooltipArgs: {
          title: 'רמלה',
          stem: 50,
          type: 'poi',
          cardDescription: 'ישראל',
          cardImageSrc: `${basePath}/pano/tags/ramia.webp`,
          transportation: { car: 10 },
        },
      },
      {
        pitch: 1.1479323909979517,
        yaw: 73.60406689731974,
        type: 'info',
        createTooltipArgs: {
          title: 'ניר צבי',
          stem: 50,
          type: 'poi',
          cardDescription: 'ישראל',
          cardImageSrc: `${basePath}/pano/tags/nir-tzvi.webp`,
          transportation: { car: 15 },
        },
      },
      {
        pitch: 3.0945197870381254,
        yaw: 89.35976294151271,
        type: 'info',
        createTooltipArgs: {
          title: 'ראשון לציון',
          stem: 50,
          type: 'poi',
          cardDescription: 'ישראל',
          cardImageSrc: `${basePath}/pano/tags/rishon-lezion.webp`,
          transportation: { car: 25 },
        },
      },
      // Scene transition hotspots
      {
        pitch: 3,
        yaw: 60,
        type: 'scene',
        createTooltipArgs: {
          title: 'תצפית 2',
          stem: 50,
          type: 'scene',
          sceneId: 2,
          imgSrc: `${basePath}/pano/tags/scene_2.webp`,
        },
      },
      {
        pitch: 5,
        yaw: 17,
        type: 'scene',
        createTooltipArgs: {
          title: 'תצפית 1',
          stem: 50,
          type: 'scene',
          sceneId: 1,
          imgSrc: `${basePath}/pano/tags/scene_1.webp`,
        },
      },
    ],
  },
};
